module.exports = __webpack_public_path__ + "static/media/hcl.2c0821a5.svg";